import { Injectable } from "@angular/core";
import Keycloak from "../../lib/keycloak-js/keycloak";
import {
    KeycloakInstance,
    KeycloakPromise,
} from "../../lib/keycloak-js/keycloak";

@Injectable()
export class KeycloakService {
    static instance: KeycloakInstance;

    static init(
        configUrl: string,
        kcAuth?: KeycloakAuth,
    ): Promise<tokenParsed> {
        const keycloak = Keycloak(configUrl);

        return new Promise((resolve, reject) => {
            let initPromise;
            if (kcAuth === undefined) {
                initPromise = keycloak.init({
                    onLoad: "login-required",
                    checkLoginIframe: false,
                });
            } else {
                initPromise = keycloak.init({
                    onLoad: "check-sso",
                    token: kcAuth.token,
                    refreshToken: kcAuth.refreshToken,
                    idToken: kcAuth.idToken,
                    checkLoginIframe: false,
                });
            }

            initPromise
                .success(() => {
                    KeycloakService.instance = keycloak;
                    if (!keycloak.tokenParsed) {
                        console.warn("Token not parsed after init success");
                    }
                    resolve(keycloak.tokenParsed as tokenParsed);
                })
                .error(reject);
        });
    }

    logout(options: any): KeycloakPromise<void, void> {
        return KeycloakService.instance.logout(options);
    }

    getToken(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (!KeycloakService.instance || !KeycloakService.instance.token) {
                console.error("Keycloak not initialized");
                reject("Keycloak not initialized");
            }
            KeycloakService.instance
                .updateToken(0)
                .success(() => {
                    if (!KeycloakService.instance.token) {
                        console.error("Received empty token from keycloak");
                    }
                    resolve(KeycloakService.instance.token as string);
                })
                .error(() => {
                    console.error("Failed to refresh token");
                    reject("Failed to refresh token");
                });
        });
    }

    getExistingParsedToken(): tokenParsed {
        if (!KeycloakService.instance.token) {
            console.error("There is no valid keycloak token yet");
        } else if (!KeycloakService.instance.tokenParsed) {
            console.error("There is no valid parsed keycloak token yet");
        }
        return KeycloakService.instance.tokenParsed as tokenParsed;
    }

    async awaitExistingParsedToken(): Promise<tokenParsed> {
        await this.getToken();
        return this.getExistingParsedToken();
    }
}

export class KeycloakAuth {
    token: string;
    refreshToken: string;
    idToken: string;
}

export type tokenParsed = typeof KeycloakService.instance.tokenParsed & {
    buid: string;
    ou: string;
    name?: string;
};
